export default __webpack_public_path__ + "static/media/time_field_drop_down.b9460654.png";